var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("Component 1")]),_c('ul',_vm._l((100),function(index){return _c('li',{key:index,style:('background-color: rgb(' + (255 - (index* 2.5)) + ', ' + (255 - (index* 2.5)) + ', ' + (255 - (index* 2.5)) + ');')},[_vm._v(" "+_vm._s(index)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }